import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { usePostUserMutation } from 'api/api'
import { Link, useNavigate } from 'react-router-dom'
import LoadingBlocker from '../../components/LoadingSpinner/LoadingBlocker'
import PasswordInput from '../../components/PasswordInput/PasswordInput'
import Logo from '../../assets/images/logo.png'

const SignupView = ({ user, onSubmit }) => {
  const navigate = useNavigate()

  const [postUser, { isLoading, error }] = usePostUserMutation()
  const errors = error?.data?.errors || []
  const schema = Yup.object().shape({
    name: Yup.string().required('User Name is required'),
    email: Yup.string()
      .required('Email is a required field')
      .email('Invalid email format'),
    password: Yup.string()
      .required('Password is a required field')
      .min(8, 'Password must be at least 8 characters'),
    terms: Yup.boolean()
      .oneOf(
        [true],
        'You must accept the terms in order to create your account.',
      )
      .required('The terms and conditions must be accepted.'),
  })

  function handleSubmit(values) {
    postUser(values).then((res) => {
      if (!res?.error) {
        navigate('/challenge')
      }
    })
  }

  useEffect(() => {
    if (user?.id) {
      navigate('/library')
    }
  }, [navigate, user?.id])

  return (
    <div className="flex w-full h-full items-center justify-center h-full relative overflow-hidden">
      <div className="login-bg"></div>
      <div className="w-[600px]">
        <div className="flex items-center mb-6">
          <img src={Logo} alt="Sharefolio logo" className="w-[48px]" />
          <div className="text-salmon font-heading font-bold ml-2 text-4xl pt-2">
            Sharefolio
          </div>
        </div>
        <div className="bg-gray-light p-12 rounded drop-shadow-lg mb-10 relative">
          <h2 className="mb-6">Create your Sharefolio account</h2>

          {errors?.length > 0 && (
            <div className="p-4 bg-pink-dark rounded border border-pink-error mb-4">
              {errors.map(({ error }, i) => (
                <p key={i}>{error}</p>
              ))}
            </div>
          )}
          <Formik
            validationSchema={schema}
            initialValues={{ email: '', password: '', terms: false }}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <div className="login">
                <div className="form">
                  <form noValidate onSubmit={handleSubmit}>
                    <label htmlFor="name">Username</label>
                    <input
                      type="text"
                      name="name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                      placeholder="Enter username"
                      className="form-control inp_text"
                      id="name"
                    />
                    <p className="error">
                      {errors.name && touched.name && errors.name}
                    </p>
                    <label className="mt-4 inline-block" htmlFor="email">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      placeholder="Enter email"
                      className="form-control inp_text"
                      id="email"
                    />
                    <p className="error">
                      {errors.email && touched.email && errors.email}
                    </p>
                    <label className="mt-4 inline-block" htmlFor="Password">
                      Password
                    </label>
                    <PasswordInput
                      name="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      placeholder="Enter password"
                      className="form-control"
                    />
                    <p className="error">
                      {errors.password && touched.password && errors.password}
                    </p>
                    <div className="flex mt-6 ml-1">
                      <div className="mr-4 mt-2">
                        <input
                          type="checkbox"
                          name="terms"
                          id="terms"
                          onChange={(e) =>
                            setFieldValue('terms', e.target.checked)
                          }
                        />
                      </div>
                      <div>
                        <label htmlFor="terms" className="text-base">
                          I agree to the{' '}
                          <a
                            className="link"
                            href="https://sharefol.io/policies/terms"
                            target="_blank"
                          >
                            Sharefolio Terms and Conditions
                          </a>{' '}
                          and{' '}
                          <a
                            className="link"
                            href="https://sharefol.io/policies/privacy"
                            target="_blank"
                          >
                            Privacy Policy
                          </a>
                        </label>
                      </div>
                    </div>
                    <p className="error">{errors.terms}</p>
                    <div className="flex justify-end pt-6">
                      <div>
                        <Link
                          className="button bg-transparent hover:bg-gray-dark text-white-dark inline-block mr-2"
                          to="/login"
                        >
                          Cancel
                        </Link>
                      </div>
                      <div>
                        <button
                          className="button bg-purple-light hover:bg-purple-light-med"
                          type="submit"
                        >
                          Sign Up
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </Formik>
          {isLoading && <LoadingBlocker />}
        </div>
      </div>
    </div>
  )
}

export default SignupView
